import React, { useState, useEffect, useCallback } from 'react';
import { useBeforeUnload } from 'react-router-dom'; // Recommended for React Router
import Hero from '../components/Hero';
import ServicesSection from '../components/ServiceSection';
import AboutUs from '../components/AboutSection';
import WhyChooseUs from '../components/WhyCHooseUs';
import ProductBanner from '../components/Product';
import ConsultationComponent from '../components/ConsultationComponent';
import TestimonialGlobe from '../components/Testimonial';
import PartnerMarquee from '../components/PartnersMarqueeComponent';

function HomePage() {
  // State to track if there are unsaved changes
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  // Optional: Use this method to set unsaved changes when needed
  const markUnsavedChanges = () => {
    setHasUnsavedChanges(true);
  };

  // Use react-router-dom's useBeforeUnload hook for more reliable prevention
  useBeforeUnload(
    React.useCallback(() => {
      // Only show prompt if there are actually unsaved changes
      return hasUnsavedChanges;
    }, [hasUnsavedChanges])
  );

  return (
    <div>
      <Hero />
      <div style={{ marginTop: '20px' }}>
        <ServicesSection />
      </div>
 
      <AboutUs />
      
      <div style={{ marginTop: '60px' }}>
        <ProductBanner />
      </div>
    
      <div style={{ marginTop: '-50px' }}>
        <WhyChooseUs />
      </div>
      <div style={{ marginTop: '40px' }}>
        <ConsultationComponent />
      </div>
      <div style={{ marginTop: '70px' }}>
        <TestimonialGlobe /> 
      </div>
      
      <div style={{ marginTop: '-180px' }}>
        <PartnerMarquee />
      </div>
    </div>
  );
}

export default HomePage;